module.exports = __webpack_public_path__ + "static/bg03-148ecabd1c7438d20dca9138bbc21be5.jpg";